import { Link } from "react-router-dom";
import { PageShell } from "../components/Layout/PageShell";
import { IconArrowRight, IconStore } from "../components/icons/icons";
import buttonStyles from "../components/Button/Button.module.css";
import styles from "./RootPage.module.css";

export function RootPage() {
  return (
    <PageShell>
      <div className={styles.page}>
        <div className={styles.card}>
          <span className={styles.mark}>
            <IconStore width={26} height={26} />
          </span>
          <h1 className={styles.heading}>One signup page per retailer</h1>
          <p className={styles.body}>
            Each retailer keeps its own branded signup page and member list here. Shoppers join through
            their retailer's own link or QR code — there's no general signup on this page. Business owners
            and administrators sign in below to manage their workspace.
          </p>
          <div className={styles.actions}>
            <Link className={`${buttonStyles.button} ${buttonStyles.primary}`} to="/owner">
              Sign in
              <IconArrowRight width={16} height={16} />
            </Link>
          </div>
        </div>
      </div>
    </PageShell>
  );
}
